import { CameraOutlined } from '@ant-design/icons'
import { Toast } from '@seiue/ui'
import { Upload, Avatar } from 'antd'
import React from 'react'
import styled from 'styled-components'

import { fileApi } from 'packages/sdks-next/growp'

import { updateReflection } from '@/utils/data'
import { getTheme } from '@/utils/theme'

import { useUserDetailContext } from './context'

/**
 * 头像上传与展示
 *
 * @param param - 参数
 * @param param.name - 用户姓名
 * @param param.src - 头像链接
 * @param param.isEdit - 是否编辑状态
 * @returns React.ReactNode
 */
export const AvatarUpload: React.FC<{
  name: string
  src: string
  isEdit?: boolean
}> = ({ name, src, isEdit }) => {
  const theme = getTheme()
  const { id, updateInfo } = useUserDetailContext()
  const { api: uploadAvatar } = fileApi.useFileUpload()

  const beforeUpload = async (file: File & { uid: string }) => {
    const { data } = await uploadAvatar({
      name: file.uid,
      payload: {
        file,
      },
    })
    if (!updateInfo) return
    updateInfo({
      id,
      payload: {
        avatar: data.url,
      },
    })

    updateReflection({
      modifyKeys: ['avator'],
      newData: {
        avator: data.url,
      },
    })

    Toast.success('头像更新成功')
    return false
  }

  return (
    <StyledUpload
      beforeUpload={beforeUpload}
      showUploadList={false}
      maxCount={1}
      disabled={!isEdit}
      accept="image/*"
    >
      <AvatarWrapper style={{ cursor: isEdit ? 'pointer' : 'default' }}>
        <Avatar
          alt="图片出错了"
          size={100}
          src={src}
          style={{
            backgroundColor: theme.border.greyDark,
            fontSize: '40px',
            fontWeight: '400px',
            color: '#FFFFFF',
            lineHeight: '56px',
          }}
        >
          {name}
        </Avatar>
        {isEdit ? (
          <CameraWrapper>
            <CameraOutlined style={{ fontSize: '12px' }} />
          </CameraWrapper>
        ) : null}
      </AvatarWrapper>
    </StyledUpload>
  )
}

const AvatarWrapper = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  padding: 10px 0 0 0;
`

const CameraWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.border.greyLight};
  position: absolute;
  right: -8px;
  bottom: -15px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledUpload = styled(Upload)`
  width: 100px;
  height: 100px;
`
